import { IsString, IsIn, IsNotEmpty, IsOptional } from 'class-validator';

import { Banner } from './banner.dto';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class WidgetBannerDto {
  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  name: string;

  @IsString()
  @IsIn(['simple', 'construct'])
  @IsNotEmpty()
  type: 'simple' | 'construct';

  @IsOptional()
  slides: Banner[];
}
